import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import Logo from "./Logo";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-800 text-secondary-300 py-8 print:hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-primary-500 p-2 rounded-lg">
                <Logo className="h-5 w-5 text-white" />
              </div>
              <span className="text-lg font-bold text-white">
                SevenServings
              </span>
            </div>
            <p className="text-sm text-secondary-400">
              Simplify your meal planning and spend less time wondering
              what&apos;s for dinner.
            </p>
          </div>

          {/* Quick Links */}
          <div aria-label="Quick Links">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/meals"
                  className="text-sm hover:text-white transition-colors"
                >
                  Meals
                </Link>
              </li>
              <li>
                <Link
                  to="/meal-plans"
                  className="text-sm hover:text-white transition-colors"
                >
                  Meal Plans
                </Link>
              </li>
              <li>
                <Link
                  to="/shopping-lists"
                  className="text-sm hover:text-white transition-colors"
                >
                  Shopping Lists
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm hover:text-white transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm hover:text-white transition-colors"
                >
                  Privacy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm hover:text-white transition-colors"
                >
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div aria-label="Account">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Account
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/login"
                  className="text-sm hover:text-white transition-colors"
                >
                  Login
                </Link>
              </li>
              <li>
                <Link
                  to="/register"
                  className="text-sm hover:text-white transition-colors"
                >
                  Register
                </Link>
              </li>
              <li>
                <Link
                  to="/settings"
                  className="text-sm hover:text-white transition-colors"
                >
                  Settings
                </Link>
              </li>
            </ul>
          </div>

          {/* Social (hidden until social profiles are set up) */}
          {false && (
            <div aria-label="Social Media">
              <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
                Follow Us
              </h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://facebook.com/sevenservings"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm hover:text-white transition-colors"
                  >
                    Facebook
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/sevenservings"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm hover:text-white transition-colors"
                  >
                    Twitter
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/sevenservings"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm hover:text-white transition-colors"
                  >
                    Instagram
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-secondary-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-secondary-400">
            &copy; {currentYear} SevenServings. All rights reserved.
          </p>
          <p className="text-sm text-secondary-400 flex items-center gap-1">
            Made with <Heart className="h-4 w-4 text-error-500" /> for home
            cooks everywhere
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
